module.exports = __webpack_public_path__ + "img/17-16-24.32de8e0c.jpg";